import React, {lazy } from 'react';

// const Overview = lazy(() => import('./../Pages/Overview'));
// const Activities = lazy(() => import('./../Pages/Activities'));
// const Activity = lazy(() => import('./../Pages/Activity'));
// const Videos = lazy(() => import('./../Pages/Videos'));
// const Stories = lazy(() => import('./../Pages/Stories'));
// const Story = lazy(() => import('./../Pages/Story'));
// const Course = lazy(() => import('./../Pages/Course'));

import Overview from './../Pages/Overview';
import Activities from './../Pages/Activities';
import Activity from './../Pages/Activity';
import Videos from './../Pages/Videos';
import Stories from './../Pages/Stories';
import Story from './../Pages/Story';
import Course from './../Pages/Course';

const Routes = [
  {
    path: '/',
    name: 'overview',
    exact: true,
    component: Overview,
  },
  {
    path: '/activities',
    name: 'activities',
    exact: true,
    component: Activities,
  },
  {
    path: '/activities/:activity',
    name: 'activity',
    exact: true,
    component: Activity,
  },
  {
    path: '/videos',
    name: 'videos',
    exact: true,
    component: Videos,
  },
  {
    path: '/stories',
    name: 'stories',
    exact: true,
    component: Stories,
  },
  {
    path: '/stories/:story',
    name: 'story',
    exact: true,
    component: Story,
  },
  {
    path: '/course',
    name: 'course',
    exact: true,
    component: Course,
  },
];

export default Routes;
